import { Nullable } from '@/utils/types';

export function getDisplayNameWithCount (value: Nullable<{ name: string }[]>, type: string): string {
  if (!value?.length) {
    return '';
  }

  let names = value[0].name.trim();
  const count = value.length - 1;

  if (count > 0) {
    names += ` (+ ${count} ${type}${count > 1 ? 's' : ''})`;
  }

  return names;
}
